import Chatbot from "@/types/Chatbot.interface"

interface State {
    chatbotsViewChatbots: Chatbot[]
    chatbotsViewSelectedChatbot: Chatbot
}

const defaults = () => {
    return {
        chatbotsViewChatbots: [],
        chatbotsViewSelectedChatbot: null
    }
}

export default {
    state: defaults(),
    mutations: {
        //  CHATBOTS
        chatbotsViewChatbotsPush (state: State, chatbots: Chatbot[]): void {
            //  Update our list
            state.chatbotsViewChatbots = window.removeDuplicatesById(state.chatbotsViewChatbots, chatbots)

            //  Get the currently selected chatbot
            const selectedChatbot = state.chatbotsViewSelectedChatbot

            //  If the chatbot does NOT exist, we have nothing to do
            if (!selectedChatbot) return

            //  Else, find the selected chatbot in the array of updated chatbots
            const updatedChatbot = chatbots.find((x: Chatbot) => x.id === selectedChatbot.id)

            //  If the selected chatbot was NOT updated, we have nothing to do
            if (!updatedChatbot) return

            //  Else, update the selected chatbot
            state.chatbotsViewSelectedChatbot = updatedChatbot
        },
        chatbotsViewChatbotsRemove (state: State, ids: number[]): void {
            //  Get our current lists of chatbots
            const chatbots = state.chatbotsViewChatbots

            //  If no chatbots, do nothing
            if (!chatbots) return

            //  Else, filter out our removed ids
            const filtered = chatbots.filter((x: Chatbot) => !ids.includes(x.id))

            //  Set our chatbots to the filtered list
            state.chatbotsViewChatbots = filtered

            //  Get the currently selected chatbot
            const selectedChatbot = state.chatbotsViewSelectedChatbot

            //  If the chatbot does NOT exist, we have nothing to do
            if (!selectedChatbot) return

            //  Else, check if this chatbot was deleted
            const deleted = ids.find((x: number) => x === selectedChatbot.id)

            //  If the selected chatbot was NOT found, then do nothing
            if (!deleted) return

            //  Else, set our selected chatbot to null
            state.chatbotsViewSelectedChatbot = null
        },
        chatbotsViewChatbotsSet (state: State, chatbots: Chatbot[]): void {
            state.chatbotsViewChatbots = chatbots
        },
        chatbotsViewSelectedChatbotSet (state: State, chatbot: Chatbot): void {
            state.chatbotsViewSelectedChatbot = chatbot
        },
        chatbotsViewReset (state: State): void {
            Object.assign(state, defaults())
        }
    },
    actions: {
        chatbotsViewSelectedChatbotGet ({ commit, getters }, chatbotId: number): Promise<void> {
            //  Grab our global chatbots dataset
            const chatbots = getters.chatbots

            //  Check if our chatbot we are searching for already exists
            const existingChatbot = chatbots.find((x: Chatbot) => x.id === chatbotId)

            //  If the chatbot was found, return it
            if (existingChatbot) return commit('chatbotsViewSelectedChatbotSet', existingChatbot)

            //  Else, we have to fin dthis chatbot so assemble our API endpoint
            const url = `${getters.api}/chatbots/${chatbotId}`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Set our selected chatbot
                commit('chatbotsViewSelectedChatbotSet', response.data)

                //  Update the global dataset
                commit('chatbotsPush', [response.data])
            }).catch(() => null)
        }
    },
    getters: {
        chatbotsViewChatbots (state: State): Chatbot[] {
            return state.chatbotsViewChatbots
        },
        chatbotsViewSelectedChatbot (state: State): Chatbot {
            return state.chatbotsViewSelectedChatbot
        }
    }
}
